import { useTheme } from "@mui/material";
import Title from "../../../pages/SharedContents/Typography";
import { Header, PageWrapper, TabContainer, Wrapper } from "./styles";
import RoleManagementTabs from "../../roleManagement/RoleManagementTabs";
import { useEffect, useState } from "react";
import { NormalTextToSnakeCase, snakeCaseToNormalText } from "../utils";

interface PropTypes {
  permissions?: any;
  onChange: (data: string) => void;
}
const SubModule = (props: PropTypes) => {
  const { permissions, onChange } = props;
  const theme = useTheme();
  const subMenus: string[] = permissions ? Object.keys(permissions) : [];
  const [activeMemberTab, setActiveMemberTab] = useState<string>(subMenus[0]);

  useEffect(() => {
    activeMemberTab && onChange(NormalTextToSnakeCase(activeMemberTab));
  }, [activeMemberTab]);

  const tabLists = subMenus.map((menu: string) => snakeCaseToNormalText(menu));

  return (
    <Wrapper
      style={{
        borderBottom: `{${theme.border?.xsmall}  ${theme?.color?.dividerLight}}`,
        borderTop: `{${theme.border?.xsmall} ${theme?.color?.dividerLight}}`,
      }}
    >
      <PageWrapper>
        <RoleManagementTabs
          tabList={tabLists}
          setParentTabState={setActiveMemberTab}
          defaultTab={activeMemberTab}
        />
      </PageWrapper>
    </Wrapper>
  );
};
export default SubModule;
